import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M9 13H3.9c-.84 0-1.26 0-1.581-.164a1.5 1.5 0 0 1-.656-.655c-.163-.32-.163-.74-.163-1.581V3.4c0-.84 0-1.26.163-1.581a1.5 1.5 0 0 1 .656-.656C2.639 1 3.059 1 3.9 1h.3c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C9 3.28 9 4.12 9 5.8M9 13V5.8M9 13h5.1c.84 0 1.26 0 1.581-.164a1.5 1.5 0 0 0 .656-.655c.163-.32.163-.74.163-1.581V3.4c0-.84 0-1.26-.163-1.581a1.5 1.5 0 0 0-.656-.656C15.361 1 14.941 1 14.1 1h-.3c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C9 3.28 9 4.12 9 5.8"
    }, null, -1)
  ])))
}
export default { render: render }